export default {
	methods:{
		reload:function() {
			window.location.reload();
		}

	}
}

